import {
    INewsDetailed, INews,
} from '@/interfaces';
import { NewsState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';


export const mutations = {
    setNews(state: NewsState, payload: INews[]) {
        state.news = payload;
    },
    setNewsDetailed(state: NewsState, payload: INewsDetailed) {
        state.newsDetailed = payload;
    },
    setImportantNews(state: NewsState, payload: INewsDetailed) {
        state.importantNews = payload;
    },
};

const {commit} = getStoreAccessors<NewsState | any, State>('');

export const commitSetNews = commit(mutations.setNews);
export const commitSetNewsDetailed = commit(mutations.setNewsDetailed);
export const commitSetImportantNews = commit(mutations.setImportantNews);
